import { css, styled } from '../../../../../../core/theme/styled';
import { InputBaseStyles, StyledLabel } from './InputField.styles';

export const StyledSelectWrapper = styled.div`
  position: relative;
`;

type StyledSelectProps = {
  hasValue?: boolean;
  floatingLabel?: boolean; // needed for InputBaseStyles
  error?: boolean; // needed for InputBaseStyles
};

/* Safari ignores the `hidden` prop on the option and still keeps displaying it in the list. To not have an empty value,
 * we add a "Please choose" text. But to not display this one in the select as default value,
 * we set the color to transparent, when the select does not have a value. */
export const StyledSelect = styled.select<StyledSelectProps>`
  ${InputBaseStyles}

  appearance: none;
  color: transparent;

  ${(props) =>
    props.hasValue &&
    css`
      color: inherit;
      & + ${StyledLabel} {
        transform: scale(0.85)
          translate(${props.theme.sizes.normedium}, ${props.theme.sizes.xsmall});
      }
    `};
`;
